import React from "react";

import { forms } from "src/modules/htx/forms";
import { FormRenderer as FormRendererBare } from "src/modules/shared/form-renderer";

export const FormRenderer: React.FunctionComponent = () => (
	<FormRendererBare forms={forms} />
);
